import { useEffect, useState } from "react";
import type { SlotProps } from "../../../core/platform/registry/registry";
import { recordsForShift } from "../data/records";
import { formatPesos } from "../../../theme/loyalty";

/**
 * Rewards given away this shift, at shift close (specs/006-loyalty FR-036):
 * how many, and what they would have cost at full price. From this till's own
 * records, net of any given back by a void or refund — so it is right offline.
 */
export function ShiftSummary({ shiftId }: SlotProps) {
  const [figures, setFigures] = useState<{ count: number; value: number } | null>(null);

  useEffect(() => {
    if (typeof shiftId !== "string") return;
    let cancelled = false;
    void recordsForShift(shiftId).then((records) => {
      let count = 0;
      let value = 0;
      for (const record of records) {
        if (record.kind === "earn") {
          count += record.redemptions.length;
          value += record.redemptions.reduce((total, r) => total + r.fullPrice, 0);
        } else {
          count -= record.redemptionReversals.length;
          value -= record.redemptionReversals.reduce((total, r) => total + r.fullPrice, 0);
        }
      }
      if (!cancelled) setFigures({ count, value });
    });
    return () => {
      cancelled = true;
    };
  }, [shiftId]);

  if (!figures) return null;
  return (
    <div className="loy__summary">
      <span>Loyalty rewards</span>
      <span className="money">
        {figures.count} · {formatPesos(figures.value)}
      </span>
    </div>
  );
}
